export enum TemplateBuilderTypes {
    STANDARD,
    MEDIA
}